// extracted by mini-css-extract-plugin
export default {"tabs":"options_tabs__-4gJ9","tab":"options_tab__b6Jyv","mobile":"options_mobile__LjAIB","line":"options_line__B66YQ"};